export default __webpack_public_path__ + "static/media/select.a12df6f5.svg";